











































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { Uploader, ImagePreview, Toast } from "vant";
import lrz from "lrz";

@Component({
  components: {
    [Uploader.name]: Uploader
  }
})
export default class CustomUploader extends Vue {
  @Prop({
    type: Object,
    default() {
      return {};
    }
  })
  private value;
  @Prop({
    type: String,
    default: ""
  })
  private title;
  @Prop({
    type: String,
    default: ""
  })
  private backgroundImg;

  @Prop({ type: String, default: "image/*" })
  private acceptType;
  @Prop({
    type: Boolean,
    default: false
  })
  private disabledImg;

  uploadImg = "";
  pdfUrl = "";
  isPdf = false;
  pdfViewShow = false;
  file = '';
  toast:any = '';
  @Watch("value", { deep: true, immediate: true })
  watchValue(val) {
    if(!this.file){
      this.uploadImg = val.url;
    }
  }
  beforeRead(){
    this.toast = Toast.loading({
      // mask: true, //蒙层
      duration: 0, // 持续展示 toast
      forbidClick: true, // 禁用背景点击
      loadingType: "spinner",
      message: (this as any).$t("common.uploading_text")
    });
    return true;
  }
  handleUpload(file) {
    this.file = file;
    // 
    const params = new FormData();
    this.isPdf = file.file.type.includes("pdf");

    if (this.isPdf) {
      params.append("file", file.file);
      params.append("put_dir", "gygjqh_id_card");
      params.append("vtype", "2");
      (this as any).$apis
        .uploadFile(params)
        .then(res => {
          
          this.$emit("afterUpload", res);
          this.$emit("input", res);
        })
        .catch(err => {
          
        }).finally(()=>{
        this.toast.clear()
      });
    } else {
      if(file && file.content){
        this.uploadImg = file.content;
      }
      lrz(file.file, {
        quality: 0.7
      })
        .then(compressRes => {
          file = compressRes;
          params.append("file", file.file);
          params.append("put_dir", "gygjqh_id_card");
          (this as any).$apis
            .uploadFile(params)
            .then(res => {
              // this.base64 = compressRes.base64;
              this.uploadImg = file.base64;
              
              this.$emit("afterUpload", { ...res, file });
              this.$emit("input", res);
            })
            .catch(err => {
              this.uploadImg = '';
              
            }).finally(()=>{
            this.toast.clear()
          });
        })
        .catch(err => {
          params.append("file", file.file);
          params.append("put_dir", "gygjqh_id_card");
          (this as any).$apis
            .uploadFile(params)
            .then(res => {
              // this.base64 = compressRes.base64;
              this.uploadImg = file.base64;
              
              this.$emit("afterUpload", { ...res, file });
              this.$emit("input", res);
            })
            .catch(err => {
              
            }).finally(()=>{
            this.toast.clear()
          });
        });


    }
  }

  handlePreview() {
    if (this.isPdf) {
      this.pdfUrl = (this as any).$apis.getStatementPdfPreviewUrl(this.uploadImg);
      this.pdfViewShow = true;
    } else {
      ImagePreview([this.uploadImg]);
    }
  }

  handleReset() {
    if(this.disabledImg) return
    this.uploadImg = "";
    this.pdfUrl = "";
    this.$emit("input", {});
  }
}
